module.exports = __webpack_public_path__ + "img/9788982735622.c05110c6.jpg";